import { useQueryState } from 'hooks/useQueryState';

import { useQueryGetSingleTemplate } from 'api/queries/getSingleTemplate.query';

import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import classes from 'components/pages/PhasePerformanceManageAddTemplatePage/components/AddTemplate/AddTemplate.module.scss';
import { Phases } from 'components/pages/PhasePerformanceManageAddTemplatePage/components/AddTemplate/components/Phases/Phases';

export const AddTemplate = () => {
    const [templateId] = useQueryState('templateId');

    const { data } = useQueryGetSingleTemplate(templateId);

    return (
        <WidgetWithTitle title={'Add & Edit Template'}>
            <div className={classes.contentWrapper}>
                <Phases templateData={data} isEditMode={Boolean(templateId)} />
            </div>
        </WidgetWithTitle>
    );
};
